import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from "../hooks/use-auth";

interface GuardPrivateRoutesProps {
  children: React.ReactNode;
}

const GuardPrivateRoutes: React.FC<GuardPrivateRoutesProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default GuardPrivateRoutes;


